import {Space} from 'src/design/atoms/Space';
import React from 'react';
import {ListCurrentUserActionAssignments} from 'src/app/actions/Dashboard/ListCurrentUserActionAssignments';
import ListCurrentUserActionDefinitions from 'src/app/actions/Dashboard/ListCurrentUserActionDefinitions';

export const MyActionsTab: React.FC = () => {
  return (
    <>
      <ListCurrentUserActionAssignments />
      <Space pb="xl" />
      <ListCurrentUserActionDefinitions />
    </>
  );
};
